<template lang="pug">
    d2-container
        el-form(:inline='true', :model='dataForm'  size='mini' label-width="75px" label-position='left' :modal-append-to-body='false'  label-suffix=':' )
            el-row(:span='24')
              el-col(:md='7' :sm="12")
                el-form-item(label="规程标题" )
                    el-input.inputWidth(v-model="dataForm.title" placeholder="请填规程标题" type="text" )
              el-col(:md='7' :sm="12")
                el-form-item(label="类型" )
                   el-select.inputWidth(v-model='dataForm.type' placeholder="请选择类型"  clearable)
                      el-option(value="1" label='竞赛')
                      el-option(value="2" label='培训')
              el-col(:md='7' :sm="12")
                el-form-item(label="发布时间")
                    el-date-picker.inputWidth(  v-model='dataForm.publishTime'  range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd")
        el-row(style="padding-bottom:15px;" :span="24")
            el-col(:md='23' :sm="5")
                el-button(@click='addOrUpdateHandle()'  type='primary' v-if="isAuth('ct:competition:add')" ) 新建
                el-button(   type='danger' @click='deleteitem(dataListSelections)' :disabled='dataListSelections.length <= 0' v-if="isAuth('ct:competition:del')" ) 删除
            el-col( :md='1' :sm="14" style='float:right;')
                el-button(@click='getDataList()',type='primary',icon='el-icon-search',style='float:right;') 查 询
        el-table(:data="tableData" style="width: 100%" v-loading='dataListLoading' @selection-change='selectionChangeHandle' border)
            el-table-column(type='selection', header-align='center', align='center', width='50')
            el-table-column(prop='title',header-align='center',align='center',label='标题')
            el-table-column(prop='releaseTime',header-align='center',align='center',label='发布时间')
            el-table-column(prop='type',header-align='center',align='center',label='类型' )
                template(slot-scope='scope')
                    font(v-if='scope.row.type == 1') 竞赛
                    font(v-if='scope.row.type == 2') 培训
            el-table-column(prop='remark',header-align='center',align='center',label='摘要' )
                template(slot-scope='scope')
                    span(:title="scope.row.remark") {{scope.row.remark | ellipsis}}
            el-table-column(prop='',header-align='center',align='center',label='操作' width='100')
                    template(slot-scope="scope")
                      el-menu(@open="handleOpen" @close="handleClose" :collapse="isCollapse" )
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-1" @click="queryHandle(scope.row.id)" v-if="isAuth('ct:competition:detail')"  ) 查看信息
                                el-menu-item(index="1-2" @click="addOrUpdateHandle(scope.row.id,1)" v-if="isAuth('ct:competition:update') " ) 修改
                                el-menu-item(index="1-3" @click='deleteitem(scope.row.id)' v-if="isAuth('ct:competition:del')" ) 删除

        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        //新建和修改
        addOrUpdate(v-if='addOrUpdateVisible', ref="addOrUpdate",@refreshDataList='getDataList')
        //查看
        queryView(v-if='queryViewVisible', ref="queryView",@refreshDataList='getDataList')
        //- el-dialog(title="禁赛设置" :visible.sync="gamesVisible" :modal-append-to-body='false')
        //-   el-form(:model="gameForm", :rules="gameRules", ref="gameForm")
        //-     //- el-form-item(label="禁赛设置:")
        //-     el-row()
        //-       el-col(:span='24')
        //-         el-form-item(label="竞赛时间:")
        //-           el-date-picker( style='width:300px;'  v-model='gameForm.suspendStartTime' range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd")
        //-     el-form-item(label='原因说明:', prop='reason')
        //-         el-input(type="textarea" :rows="5" resize="none" v-model="gameForm.reason" )
        //-     el-row
        //-       el-col(:span='24' align='center')
        //-         el-button(type="primary" @click="gameSubmit()") 确认
        //-         el-button(@click="gamesVisible=false" style='margin-left:40px;') 取消
</template>

<script>
import AddOrUpdate from './add-or-update'
import QueryView from './query-view'
// import ElEnrollInfo from "./el-enroll-info";
// import GameInfo from "./game-info";
export default {
  name: 'ct-competition-clubList',
  data () {
    return {
      isCollapse: true,
      startScoreMin: '',
      StartScoreMax: '',
      addOrUpdateVisible: false,
      queryViewVisible: false,
      elEnrollInfoVisible: false,
      gameInfoVisible: false,
      gamesVisible: false,
      matchId: '',
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      tableData: [],
      dataForm: {
        title: '',
        type: '',
        publishTime: ''
      },
      dataListLoading: false,
      dataListSelections: [],
      gameForm: {}
    }
  },
  components: {
    AddOrUpdate,
    QueryView
    // ElEnrollInfo,
    // GameInfo
  },
  filters: {
    ellipsis (value) {
      if (!value) return ''
      if (value.length > 15) {
        return value.slice(0, 15) + '...'
      }
      return value
    }
  },
  mounted () {
    this.getDataList()
  },
  methods: {
    //操作三点
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    currentChangeHandle (val) {
      this.pageSize1 = val
      this.pageIndex1 = 1
      this.getDataList()
    },
    //新建或修改
    addOrUpdateHandle (id, flagType) {
      this.addOrUpdateVisible = true

      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, flagType)
      })
    },
    // 删除
    deleteitem (id) {
      if (typeof id !== 'string') {
        if (id.length == 0) return this.$message.error('未勾选任何项目！')
        let ids = []
        id.forEach(e => {
          ids.push(e.id)
        })
        id = ids.join()
      }
      this.$confirm('此操作将永久删除规程信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http({
            url: this.$http.adornUrl(`/pbStandards/delete/${id}`),
            method: 'get',
            params: this.$http.adornParams()
          }).then(data => {
            if (data && data.code === 0) {
              this.$message.success('删除成功!')
              this.getDataList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    //查看
    queryHandle (id, type) {
      this.queryViewVisible = true
      this.$nextTick(() => {
        this.$refs.queryView.init(id, type)
      })
    },
    //成员管理
    memberManage (id, type) {
      this.elEnrollInfoVisible = true
      this.$nextTick(() => {
        this.$refs.elEnrollInfo.init(id, type)
      })
    },
    releaseClick (id, type) {
      this.gameInfoVisible = true
      this.$nextTick(() => {
        this.$refs.gameInfo.init(id, type)
      })
    },
    deleted (id) {
      console.log(11111111)
      // this.gamesVisible = true
      this.$confirm('是否删除规程？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
    },

    getDataList () {
      this.dataListLoading = true
      let strDate = null
      let endDate = null
      if (this.dataForm.publishTime !== null) {
        if (this.dataForm.publishTime.length > 0) {
          strDate = this.dataForm.publishTime[0]
          endDate = this.dataForm.publishTime[1]
        }
      }

      this.$http({
        url: this.$http.adornUrl('/pbStandards/list'),
        method: 'post',
        data: {
          page: this.pageIndex,
          limit: this.pageSize,
          title: this.dataForm.title,
          type: this.dataForm.type,
          strDate: strDate,
          endDate: endDate
        }
      }).then(data => {
        if (data && data.code === 0) {
          this.tableData = data.page.records
          this.totalPage = data.page.total
        } else {
          this.tableData = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    }
  }
}
</script>
<style scoped >
/* 操作三点 菜单样式 */
@import "../../../css/opr3dot.css";

.inputWidth {
  width: 218px;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}
</style>
<style >
.el-input-number--mini .el-input__inner {
  padding-left: 25px;
  padding-right: 25px;
}
.el-input-number--mini .el-input-number__decrease,
.el-input-number--mini .el-input-number__increase {
  width: 24px;
  font-size: 12px;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}
</style>
